import { Button, Form, Modal, Select } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch, serviceQuestionModalSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function ServiceQuestionModal({ caption, questions, serviceQuestion }: { caption?: any; questions?: any; serviceQuestion?: any }) {
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);

    const open = useSelector((state: any) => state.serviceQuestionModal.open);
    const serviceId = useSelector((state: any) => state.serviceQuestionModal.serviceId);
    const serviceQuestionsToAdd = useSelector((state: any) => state.serviceQuestionModal.serviceQuestionsToAdd);
    const questionsToShow = useSelector((state: any) => state.serviceQuestionModal.questionsToShow);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    let serviceQuestionValuesToShow = serviceQuestionsToAdd;

    let questionDropDownList = questionsToShow?.map(q => { return ({ key: q.key, label: q.text, value: q.value }) })

    let adder = serviceQuestionAdder;
    let buttonCaption = caption;

    const onSubmit = () => {
        //We are adding a new one
        if (adder) {
            adder(null, serviceQuestionsToAdd)
        }

        dispatch({ type: serviceQuestionModalSliceDispatch.setOpen, payload: false })
    }

    const onCancel = () => {
        dispatch({ type: serviceQuestionModalSliceDispatch.setOpen, payload: false })
    }

    const onQuestionsDropDownChange = (value) => {
        let toAdd = value.map(q => ({assistanceServiceId: serviceId, questionId: q}));
        dispatch({ type: serviceQuestionModalSliceDispatch.setServiceQuestionsToAdd, payload: toAdd });
    }

    function serviceQuestionAdder(oldList, newServiceQuestions) {
        let listToUse = [];
        if (oldList) {
            listToUse = oldList ?? listToUse;
        } else {
            listToUse = currentServiceQuestions ?? listToUse
        }

        listToUse = listToUse.concat(newServiceQuestions);

        dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: listToUse });

        CreateContentsFromStates({ serviceQuestions: listToUse });
    }

    return open ? (
        <Modal
            title="Add Question(s)"
            footer={null}
            closable={false}
            open={open}
            destroyOnHidden={true}
        >
            <Form
                onFinish={onSubmit}
                onFinishFailed={onCancel}
                preserve={false}
            >
                <Form.Item>
                    <label>Question(s)</label>
                    <Select
                        placeholder='Question(s)'
                        options={questionDropDownList}
                        onChange={onQuestionsDropDownChange}
                        id="questionId"
                        mode="multiple"
                    />
                </Form.Item>
                <Form.Item>
                    <input id="assistanceServiceId" type="hidden" value={serviceQuestionValuesToShow.assistanceServiceId || 0} />
                </Form.Item>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    ) : (
        <Button onClick={() => {
            dispatch({ type: serviceQuestionModalSliceDispatch.setOpen, payload: true });
            dispatch({ type: serviceQuestionModalSliceDispatch.setServiceQuestionsToAdd, payload: [] });
            dispatch({ type: serviceQuestionModalSliceDispatch.setQuestionsToShow, payload: questions?.map(b => { return ({ key: b.questionId, text: b.dataKey, value: b.questionId }) }) });
        }}>{buttonCaption}</Button>
    )
}

export default ServiceQuestionModal;